var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"rebrandContainerRedesign accordion-panel"},_vm._l((_vm.data.accordionItems),function(item,itemIndex){return _c('AccordionItem',{key:itemIndex,attrs:{"accordionItem":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }